export default "__VITE_ASSET__CCnWoNJ9__"